import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const {
  TOKEN_NAME
} = require('../helper/application-conf').default;
import { useAppSelector } from '../store';
import { Person } from '../store/user';
import styles from '../assets/Flourish.module.css';
import { StorageService } from '../helper/storage-service';
import { useAuth } from '../hooks/useAuth';
import useRefreshToken from '../hooks/useRefreshToken';
import { initiateSocketConnection, subscribeToCompletion } from '../hooks/useSocket';

const { ProgressCircle } = require('@americanexpress/dls-react');

const Thanks: React.FC<any> = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isAuthorizedOfficer: boolean = useAppSelector((state) => state.user.authorizedOfficer);

  const authorizedOfficer: Person = useAppSelector((state) => state.authorizedOfficer);

  const SITE_NAME = window.location.pathname.split('/')[2];
  const storage = new StorageService();
  const refresh = useRefreshToken();
  const { auth } = useAuth() as any;

  useEffect(() => {
    if (isAuthorizedOfficer) {

      // TODO -- Use this code latter when we have error message for CPGOrgId failed

      // initiateSocketConnection(SITE_NAME, storage.getSession(TOKEN_NAME), auth?.role?.emailId, auth?.role?.userId);
      // subscribeToCompletion((err: any, data: { caoCompleted: any; }) => {
      //   refresh().then((refreshTokenResponse) => {
      //     storage.setSession(TOKEN_NAME, JSON.stringify(refreshTokenResponse));
      //     console.log(JSON.stringify(refreshTokenResponse));
      //   });
      //   setTimeout(() => {
      //     if (data.caoCompleted) window.location.pathname = `/${SITE_NAME}`;
      //   }, 5000);
      // });
      if (props.oneIdentityEnabled) {
        window.location.pathname = `/${SITE_NAME}/home`;
      }
      else {
        setTimeout(() => {
          refresh().then((refreshTokenResponse) => {
            storage.setSession(TOKEN_NAME, JSON.stringify(refreshTokenResponse));
            window.location.pathname = `/${SITE_NAME}`;

          });
        }, 10000);
      }
    }
  }, [isAuthorizedOfficer, t, navigate]);

  return (
      <div className='margin-4-b'>

          <div className={`container ${styles.noFilter}`}>

              <div className="row text-align-center pad-4-tb">
                  <h5 className="col-md-offset-3 col-md-6 heading-5 pad-4-t">{t('thanks.almost_done')}</h5>
              </div>
              {isAuthorizedOfficer
                  && (
                      <div className="row text-align-center">
                          <p className="col-md-offset-3 col-md-6 body-3">{t('thanks.redirect_note')}</p>
                      </div>
                  )}
              {!isAuthorizedOfficer
                  && (
                      <React.Fragment>
                          <div className="row text-align-center">
                              <p className="col-md-offset-3 col-md-6 body-3">{t('thanks.ao_email', {email: authorizedOfficer.email})}</p>
                          </div>
                          <div className="row text-align-center pad-2-t">
                              <p className="col-md-offset-3 col-md-6 body-3">{t('thanks.ao_next_steps')}</p>
                          </div>
                      </React.Fragment>
                  )}

              <div className="row text-align-center pad-2-t">
                  <p className="col-md-offset-3 col-md-6 body-3">{t('thanks.contact_note')}</p>
              </div>
              {isAuthorizedOfficer
                  && (
                      <div className="row text-align-center pad-4-t flex flex-justify-center">
                          <ProgressCircle size="lg"/>
                      </div>
                  )}
          </div>
          <div className={styles.flourishParent}></div>
          <div className={styles.flourish}/>
      </div>
  );
};

export default Thanks;
